export default __webpack_public_path__ + "c3095d7.png";